const indicatorStyles = theme => {
  const colors = theme.palette.graphColors;

  // Shared base styles for indicators
  const baseIndicator = {
    position: 'absolute',
    bottom: 0,
    width: '100%',
    height: 3,
  };

  // Helper functions to generate indicator styles
  const backgroundIndicator = color => ({
    ...baseIndicator,
    backgroundColor: color,
  });

  const borderTopIndicator = (color, style = 'solid') => ({
    ...baseIndicator,
    borderTop: `3px ${style} ${color}`,
  });

  const borderedIndicator = (color, withBackground = false) => ({
    ...baseIndicator,
    border: `1px solid ${color}`,
    borderBottom: 'none',
    ...(withBackground && {background: color}),
  });

  return {
    revIndicator: backgroundIndicator(colors.revenue),
    revRefreshIndicator: borderTopIndicator(colors.refreshRevenue),
    refreshRateIndicator: borderTopIndicator(colors.themeAlmostWhite, 'dashed'),
    CTRIndicator: borderTopIndicator(colors.CTR, 'dashed'),
    RCPMIndicator: borderTopIndicator(colors.rCPM),
    uRPMIndicator: backgroundIndicator(colors.uRPM),
    eCPMIndicator: backgroundIndicator(colors.eCPM),
    AllImpIndicitor: borderedIndicator(colors.themeDarkGray),
    PaidImpIndicitor: borderedIndicator(colors.themeDarkGray, true),
    pvRPMIndicator: borderedIndicator(colors.pvRPM, true),
    sRPMIndicator: borderedIndicator(colors.sRPM, true),
    RefreshRequestsImpIndicitor: {
      position: 'absolute',
      top: 50,
      right: 30,
      width: 25,
      height: 31,
      border: `1px solid ${colors.themeAlmostWhite}`,
      borderBottom: 'none',
      background: colors.themeAlmostWhiteOpaque,
    },
    viewabilityIndicitor: borderTopIndicator(colors.viewability, 'dashed'),
  };
};

export default indicatorStyles;
